<template>
<div class="modal-backdrop">
    <div class="modal  ">
      <header class="modal-header">
        <slot name="header">
          This is the default title!
        </slot>
        <button
          type="button"
          class="btn-close"
          @click="closet"
        >
          x
        </button>
      </header>
      <section class="modal-body">
              <div class="row flex justify-start" >
              <form id="form" class="ml-3 text-left" style=" width: 100%;">
                  <!-- devex start -->
                  <DxForm :form-data="modal_form_data"
                            :label-location="labelLocation" @field-data-changed="drop_down_change">
                        <DxGroupItem
                          :col-count="4"
                          css-class="second-group"
                        >
                            <DxSimpleItem
                              :editor-options="companyOptions"
                              data-field="company_name"
                              editor-type="dxSelectBox"
                            />
                            <DxSimpleItem
                              :editor-options="typeOptions"
                              data-field="type"
                              editor-type="dxSelectBox"
                            />
                            <DxSimpleItem
                                  v-if="is_visible=='Voucher'" 
                                  :editor-options="VoucherSubTypeOptions"
                                  data-field="subtype"
                                  editor-type="dxSelectBox"
                              />
                            <DxSimpleItem
                                  v-if="is_visible=='Master'"
                                  :editor-options="MasterSubTypeOptions"
                                  data-field="subtype"
                                  editor-type="dxSelectBox"
                              />
                            <DxSimpleItem
                              :editor-options="template_Options"
                              data-field="template_name"
                              editor-type="dxSelectBox"
                            />
                          </DxGroupItem>
                  </DxForm>
                  <!-- devex end -->
                      <div class="form-group row ml-3 mt-1" id="modal_Master" style="display:none;">
                          <span style="font-weight: 600;" class="voucher-heading ml-3  w-20">Sub-type:</span>
                          <select name="modal_subtype"
                              class="voucher-select col-md-5 modal_subtype ml-2 w-44">
                              <option value="">-NA-</option>
                              <option value="StockGroup">Stock group</option>
                              <option value="Ledger">Ledger</option>
                              <option value="Group">Group</option>
                              <option value="StockItem">Stock Item</option>
                              <option value="Godown">Godown</option>
                              <option value="Unit">Unit</option>
                          </select>
                      </div>
                  <!-- </div> -->
                  <div class="row">
                      <div class="col-lg-3 col-md-6 col-sm-12 form-group row mt-1">
                          <div class="col-lg-12 col-md-4">
                              <!-- <pre>{{valueString}}</pre> -->
                          </div>
                      </div>
                  </div>
              </form>
               <div style="text-align:left;" class="mt-2 ml-3 mb-2">
                          <!-- <button type="button" class="inventory-submit-btn "
                              @click="getJsonTemplateData_popup">Fetch</button> -->
                          <!-- <button type="submit" class="inventory-submit-btn" ng-click="insertTemplateData()">Insert</button> -->
                      </div>
              <button id="map" type="button" class=" maps  btn-primary btn-xs  ml-8 " @click="map_json">Create </button>
              <!-- <button  type="button" class="maps  btn-primary btn-xs ml-1" @click="create_master">create</button> -->
          </div>
        <slot name="body">
     
        </slot>
      </section>
     </div>
</div>
</template>
<script>
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';
import {getTemplateName,getJsonTemplatePhp,getCompanyNames_db} from '../js/import_tally.js';
import { DxTextArea } from 'devextreme-vue/text-area';
import {isElectron} from '../../UtilsJs/utils.js';
import Spreadsheet from "x-data-spreadsheet";
import {getCompanyNames,getTemplateNames,getJsonTemplate_Popup} from '../js/modal_popup_db.js';
import {processExcel,createMaster} from '../js/modal_popup_tally.js';
var is_tally_open = "";
let s;
  export default {
     components: {
      DxForm,
      DxTextArea,
      DxGroupItem,
      DxSimpleItem,
      DxLabel,
    },
      name: 'Modal',
      computed:{
              valueString() {
                    let mod = JSON.stringify(this.template_data, null, 2);
                    return mod;
                  },
                },
      props:{
          missing_data_var:{
            type:Array,
            default:{}
          },
    },
    data(){
        return{
          modal_popup_template:[],
          is_visible:"",
          labelLocation:'top',
          missing_data_var_popup:[],
          s:this.s,
          modal_template_data:[],
          processed_data:[],
          missing_masters:[],
          master_create:[],
          master_type:'',
          is_tally_open :is_tally_open,
          companyOptions:{
              items: [],
          },
          template_Options:{
              items:[],
          },
          typeOptions:{
            items: [{Show:'-NA-',Value:''},{Show:'voucher',Value:'Voucher'},{Show:'master',Value:'Master'}],
            valueExpr: "Value",
            displayExpr: "Show"
          },
          VoucherSubTypeOptions:{
                items:['Sales','Purchase','Recieve','Payment','Credit Note','Debit Note']     
          },
          MasterSubTypeOptions:{ 
              items:['StockGroup','Ledger','Group','StockItem','Godown','Unit']  
          },
          modal_form_data:{"type":"","subtype":"","company_name":"","template_name":""},
      }
    },
    methods: {
      set_data(missing_data) {
          s.loadData(missing_data);
      },
      setDataInExcel(missing_data,master_type) { 
        this.set_data(missing_data)
        this.master_type=master_type;
      },
      getJsonTemplateData_popup(){
         var _this=this;
        var params = {'form_data':this.modal_form_data};
        getJsonTemplate_Popup(_this,params);
      },
      map_json(){
        var _this=this;
        var excel_data=s.getData();
        processExcel(excel_data,_this,this.master_type);
      },
      closet(){
        
        this.$emit('close');
      },
      create_master(){
        var _this = this;
        this.meta=this.getCookie();
        createMaster(_this,this.meta);
      },
      getCookie(name) {
        const value = `; ${document.cookie}`;
        return value.split(";")[1].split("=")[1];
      } ,
      drop_down_change(e){
            if(e.value == "Voucher"){
                this.is_visible = "Voucher";
            } 
            else if(e.value == "Master"){
                this.is_visible = "Master";
            }
            if(this.modal_form_data.type && this.modal_form_data.subtype && this.modal_form_data.company_name&& this.modal_form_data.template_name == ""){
                var params = this.modal_form_data;
                var _this = this;
                getTemplateName(_this,params);
            }
            if(this.modal_form_data.type && this.modal_form_data.subtype && this.modal_form_data.company_name && this.modal_form_data.template_name){
                 var template_name = this.modal_form_data.template_name;
                 var template_params = this.modal_template_data[template_name];
                 this.modal_popup_template = template_params.json_template;
            } 
        }
    },
    created:function(){
     
    },
    mounted:function(){
                //check if tally is open 
                s = new Spreadsheet("#x-spreadsheet-demo")
                .loadData({}) // load data
                .change(data => {
                        // save data to db
                });
                // data validation
                s.validate();
                if(isElectron()){
                    var _this = this;
                    getCompanyNames_db(_this);
                }
                var template_data = [];
                if(is_tally_open == "true"){
                    //fetch company names
                    // getCompanyNames();
                }
                $('#modal_type').on('change', function () {
                    $("#Name").find('option').remove();
                    $("select[name='modal_subtype']").val([]);
                    if ($(this).val() == "Voucher") {
                        $('#modal_Voucher').css('display', 'block');
                        $('#modal_Master').css('display', 'none');
                    }
                    else {
                        $('#modal_Voucher').css('display', 'none');
                        $('#modal_Master').css('display', 'block');
                    };
                })
                $('.modal_subtype').on('change', function () {
                    $("#modal_Name").find('option').remove();
                    var formData = $('#form').serializeArray();
                    template_data = [];
                    $.each(formData, function (key, value) {
                        if (value.value != '') {
                            template_data[value.name] = value.value;
                        }
                    })
                    template_data['subtype'] = $(this).val();
                    $('#Name').val("<option value=" + $(this).val() + ">" + $(this).val() + "</value>");
                    getTemplateNames($('#modal_company').val(),template_data['modal_type'], template_data['subtype']);
                    // ipcRenderer.send('getTemplateNames', template_data['type'], template_data['subtype'],'popup');
                    // ipcRenderer.on('getTemplateNames_popup-reply', function (e, item) {
                    // })
                })
    }
  };
</script>
<style>
.btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #2A66B1;
    background: transparent;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #EEEEEE;
    color: #2A66B1;
    justify-content: space-between;  
  }
.inventory-submit-btn {
  font-size: 12px;
  border: 1px solid #2a66b1;
  color: #ffffff;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #2a66b1;
}
  .modal-backdrop {
    /* position: relative; */
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    /* display: flex;
    justify-content: center;
    align-items: center; */
    z-index: 1;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
     width: 80%;
    height: 80%;
    /* justify-content: center;  */
   margin-top: 80px;
   margin-left: 140px;
   z-index: 1;
  }
  	/* @media (min-width: 1280px) { 
      .modal{
    margin-left: 120px;
      }
     }

    	@media (min-width: 1024px) { 
         .modal{
        margin-left: 100px;
      }
       }

/* Medium devices (landscape tablets, 768px and up) */
/* @media only screen and (min-width: 768px) {
  .modal{
    margin-left: 70px;
  }
}  */

      /* @media (min-width: 768px) { 
         .modal{
       margin-left: 60px; 
      }
       }  */

      	/* @media (min-width: 640px) { 
           .modal{
        margin-left: 60px;
      }
         } */

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;   
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;  
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
    justify-content: flex-end;  
  }

  .modal-body {
    position: relative;
    padding: 20px 30px; 
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent; 
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;  
  }
.maps{
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 4px;
  }
</style>